import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { CommentUrl } from './commentUrl';
import { ShareIconBox } from './shareIconBox';
import errorBoundary from '@ifeng/errorBoundary';

class ShareBox extends React.PureComponent {
    /**
     * 渲染网页布局
     */
    render() {
        const { docData } = this.props;
        const { columnData } = docData;
        const { url } = columnData;

        return (
            <div>
                <ul className={styles.share_comment}>
                    <CommentUrl docData={docData} />
                    <li>
                        <span>|</span>
                    </li>
                    <ShareIconBox docData={docData} />
                    <li>
                        <span>|</span>
                    </li>
                    <li>
                        <a href={url} target="_blank">
                            返回栏目
                        </a>
                    </li>
                </ul>
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * */
ShareBox.propTypes = {
    docData: PropTypes.object,
};

/**
 * 定义组件默认属性
 * */
ShareBox.defaultProps = {};

export { ShareBox };
export default errorBoundary(ShareBox);
